import React, { createContext, useContext, useState, useCallback, useEffect } from 'react';
import { authAPI } from '../services/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(() => {
        // Lecture lazy (react-best-practices: rerender-lazy-state-init)
        const saved = localStorage.getItem('tcvgd_user');
        return saved ? JSON.parse(saved) : null;
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const isAuthenticated = Boolean(user && localStorage.getItem('tcvgd_token'));

    const login = useCallback(async (email, password) => {
        setLoading(true);
        setError(null);
        try {
            const { data } = await authAPI.login({ email, password });
            localStorage.setItem('tcvgd_token', data.token);
            localStorage.setItem('tcvgd_user', JSON.stringify(data.user));
            setUser(data.user);
            return data.user; // retourne l'user pour la redirection
        } catch (err) {
            const msg = err.response?.data?.message || 'Erreur de connexion.';
            setError(msg);
            throw new Error(msg);
        } finally {
            setLoading(false);
        }
    }, []);

    const register = useCallback(async (formData) => {
        setLoading(true);
        setError(null);
        try {
            await authAPI.register(formData);
        } catch (err) {
            const msg = err.response?.data?.message || "Erreur lors de l'inscription.";
            setError(msg);
            throw new Error(msg);
        } finally {
            setLoading(false);
        }
    }, []);

    const logout = useCallback(() => {
        localStorage.removeItem('tcvgd_token');
        localStorage.removeItem('tcvgd_user');
        setUser(null);
    }, []);

    const updateUser = useCallback((updatedUserData) => {
        setUser((prev) => {
            const newUser = { ...prev, ...updatedUserData };
            localStorage.setItem('tcvgd_user', JSON.stringify(newUser));
            return newUser;
        });
    }, []);

    return (
        <AuthContext.Provider value={{ user, isAuthenticated, loading, error, login, register, logout, updateUser }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => {
    const ctx = useContext(AuthContext);
    if (!ctx) throw new Error('useAuth doit être utilisé dans un AuthProvider');
    return ctx;
};
